import httpClient, { ApiResponse } from "@/api/httpClient";

export const resetDemo = async (): Promise<ApiResponse<void>> => {
  return await httpClient.post(`/demo/reset`);
};
